import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BreadcrumbsService} from "../services/breadcrumbs.service";
import {Subscription} from "rxjs";

interface Breadcrumb {
    title: string;
    id: string|null;
}

@Component({
    selector: 'app-breadcrumbs',
    imports: [CommonModule],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {

    private breadcrumbsService = inject(BreadcrumbsService);

    elements: Breadcrumb[] = [];

    private stackFolder$!: Subscription;
    private moveUpFolder$!: Subscription;

    ngOnInit(): void {
        this.elements = [
            {
                title: 'Home',
                id: null,
            }
        ];

        this.stackFolder$ = this.breadcrumbsService.stackFolder.subscribe(element => {
            this.elements.push({
                title: element.title,
                id: element.id,
            });
            this.breadcrumbsService.level = this.elements.length - 1;
        });

        this.moveUpFolder$ = this.breadcrumbsService.moveUpFolder.subscribe(element => {
            // remove last element
            this.elements.pop();
            this.breadcrumbsService.level = this.elements.length - 1;
            this.breadcrumbsService.openFolder.next(this.elements[this.elements.length - 1].id);
        });
    }

    ngOnDestroy() {
        this.stackFolder$.unsubscribe();
        this.moveUpFolder$.unsubscribe();
    }

    setFolder(event: any, element: any): void {
        event.preventDefault();

        // get id of element
        this.elements.indexOf(element);
        // remove all elements after this one
        this.elements.splice(this.elements.indexOf(element) + 1);

        this.breadcrumbsService.level = this.elements.length - 1;

        this.breadcrumbsService.openFolder.next(element.id);
    }
}
